interface IFlightDestinationTypes {
  origin: string;
  destination: string;
}

export const FlightDestinationTypes: IFlightDestinationTypes = {
  origin: "origin",
  destination: "destination",
};
